import { E as EventProperties } from "../../index-5e4e4f4b.js";
import { u as useInView } from "../../index-2d889c01.js";
import { useInsights } from "./useInsights.js";
import "../../axios-5f69b112.js";
import "../../_commonjsHelpers-0c53d963.js";
import "react";
import "../../utils/noOp.js";
import "../useLogger/constants.js";
import "../useLogger/useLogger.js";
import "../useLogger/LoggerContext.js";
import "react/jsx-runtime";
import "../useLogger/types.js";
import "./InsightsContext.js";
function useInsightsImpression(eventData, options = {}) {
  const { trackAllImpressions = !1, useInsightsOptions } = options, { trackAnalyticsEvent } = useInsights(useInsightsOptions), { ref } = useInView({ triggerOnce: !trackAllImpressions, onChange: onInViewChange, skip: !eventData });
  function onInViewChange(...[inView]) {
    if (inView && eventData) {
      const impressionData = {
        ...EventProperties.IMPRESSION,
        ...eventData
      };
      trackAnalyticsEvent(impressionData);
    }
  }
  return { impressionRef: ref };
}
export {
  useInsightsImpression
};
//# sourceMappingURL=useInsightsImpression.js.map
